import AuthRepository from '@/repositories/fo-manual-API/AuthRepository';
import linksRepository from '@/repositories/fo-manual-API/LinksRepository/LinksRepository';
import { Repositories } from '@/repositories/fo-manual-API/IEntityRepository';

const repositories: Repositories = {
  auth: AuthRepository,
  links: linksRepository,
};

export default {
  get: <U extends keyof Repositories>(key: U) => repositories[key],
};
